<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="会员ID｛member.id｝" prop="memberId" >
        <a-input v-model="form.memberId" placeholder="请输入会员ID｛member.id｝" />
      </a-form-model-item>
      <a-form-model-item label="订单编号" prop="orderNo" >
        <a-input v-model="form.orderNo" placeholder="请输入订单编号" />
      </a-form-model-item>
      <a-form-model-item label="用户ID｛user.id｝" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户ID｛user.id｝" />
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status" >
      </a-form-model-item>
      <a-form-model-item label="支付方式" prop="payMethod" >
        <a-input v-model="form.payMethod" placeholder="请输入支付方式" />
      </a-form-model-item>
      <a-form-model-item label="总金额" prop="totalAmount" >
        <a-input v-model="form.totalAmount" placeholder="请输入总金额" />
      </a-form-model-item>
      <a-form-model-item label="优惠金额" prop="discountAmount" >
        <a-input v-model="form.discountAmount" placeholder="请输入优惠金额" />
      </a-form-model-item>
      <a-form-model-item label="支付时间" prop="payTime" >
        <a-date-picker style="width: 100%" v-model="form.payTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="实付金额" prop="payAmount" >
        <a-input v-model="form.payAmount" placeholder="请输入实付金额" />
      </a-form-model-item>
      <a-form-model-item label="会员截止日期" prop="validDate" >
        <a-date-picker style="width: 100%" v-model="form.validDate" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
// import { getMemberOrder, addMemberOrder, updateMemberOrder } from '@/api/member/memberOrder'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        memberId: null,

        orderNo: null,

        userId: null,

        status: 0,

        payMethod: null,

        totalAmount: null,

        discountAmount: null,

        payTime: null,

        payAmount: null,

        validDate: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        memberId: [
          { required: true, message: '会员ID｛member.id｝不能为空', trigger: 'blur' }
        ],
        orderNo: [
          { required: true, message: '订单编号不能为空', trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '用户ID｛user.id｝不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态不能为空', trigger: 'blur' }
        ],
        payMethod: [
          { required: true, message: '支付方式不能为空', trigger: 'blur' }
        ],
        totalAmount: [
          { required: true, message: '总金额不能为空', trigger: 'blur' }
        ],
        discountAmount: [
          { required: true, message: '优惠金额不能为空', trigger: 'blur' }
        ],
        payAmount: [
          { required: true, message: '实付金额不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        memberId: null,
        orderNo: null,
        userId: null,
        status: 0,
        payMethod: null,
        totalAmount: null,
        discountAmount: null,
        payTime: null,
        payAmount: null,
        validDate: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getMemberOrder({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateMemberOrder(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addMemberOrder(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
